import { FC } from "react";
import { Box } from "@mui/material";
import { InputField, TreeView } from "components";

type ISidebarProps = {
  setSearch: (search: string) => void;
  search: string;
};

export const Sidebar: FC<ISidebarProps> = ({ setSearch, search }) => {
  return (
    <Box className="sidebar">
      <InputField
        placeholder="Search here..."
        onChange={(e) => setSearch(e.target.value)}
      />
      <TreeView search={search} />
    </Box>
  );
};
